export const privacyContent = [
  {
    title: "1. Information Collection",
    text: "We collect personal information when you use our services or contact us through the website. This may include your name, email address, and other details you provide to us via forms or email.",
  },
  {
    title: "2. Use of Information",
    text: "The information we collect is used to provide you with better services, respond to your inquiries, and send updates about our offerings. We do not share your personal information with third parties, except where required by law.",
  },
  {
    title: "3. Data Security",
    text: "We implement industry-standard security measures to protect your data from unauthorized access, alteration, or destruction. However, no system is entirely secure, and we cannot guarantee complete security.",
  },
  {
    title: "4. Cookies",
    text: "Our website uses cookies to enhance user experience. Cookies are small text files stored on your device that help us track your preferences and improve our services.",
  },
  {
    title: "5. Your Rights",
    text: "You have the right to access, update, or delete your personal information at any time. If you wish to exercise these rights, please contact us.",
  },
  {
    title: "6. Changes to This Privacy Policy",
    text: "We may update this Privacy Policy from time to time. Any changes will be posted on this page.",
  },
  {
    title: "7. Third-Party Services",
    text: "Our website may contain links to third-party services. We are not responsible for their privacy practices. Please review their privacy policies before sharing your information.",
  },
  {
    title: "8. Contact & Compliance",
    text: "For questions about our privacy practices or to exercise your data rights, please contact us. We comply with applicable data protection regulations including GDPR where applicable.",
  },
];
